<div class="grid auto-rows-auto gap-y-4 justify-items-center">
    <i class="material-icons text-6xl text-vivid-blue">construction</i>
    <h2 class="font-bold text-center text-lg">This is awkward. You caught us a little unprepared.</h2>
    <p>Thank you for your interest. We are still hard at work constructing this new feature to help streamline the
        document
        uploading process.</p>
    <button mat-flat-button color="primary" class="px-4" (click)="uploadDocumentsClick()">Upload Documents</button>
</div>